export const blockLink = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, link: string) => {
  if (window.location.pathname === link) {
    e.preventDefault();
  }
};
